import { Route, createPageRoute, AppId } from '@lumapps/router';

const surveysRoute: Route = createPageRoute({
    slug: 'surveys',
    appId: AppId.backOffice,
});

export { surveysRoute };
